import RecoverStep from "../recover_step";
import {getUrl, parentChangeColor, parentCounterDecrement} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'offsite-file-browse';

// Define download type
const SINGLE_FILE = 1;
const SINGLE_ZIP = 2;
const SINGLE_TAR = 3;
const MULTIPLE_TAR = 4;

export default class Browse extends RecoverStep {

    constructor() {
        super(TEMPLATE);
        this.resetRestoredItems();
    }

    open(data, el, fr, previousStep) {
        // If the 'back' button is clicked, unset already selected files and folders, reset counters
        this.resetRestoredItems();
        data.restore.zip = data.restore.tar = undefined;
        data.render = { searchComplete: false };
        this.mountFS(data, fr);
    }

    loadFS(data, fr) {
        $.ajax({
            type: "POST",
            url: '/api/filebrowsing/files/' + data.recovery.appliance_id + '/' + data.recovery.device_asid + '/'
                + data.recovery.job_id + '/' + data.recovery.drive,
            data: JSON.stringify({
                path: '',
                recoveryPoint: data.recovery.point,
                filemountUseId: data.filemountUseId
            }),
            success: (response) => {
                data.fs = response.data;
                // Do not update - always keep root folder info
                data.rootpath = response.data;
                this.renderFS(data, fr);
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    renderFS(data, fr) {
        data.render.searchComplete = true;
        if (!data.fs) {
            fr.goTo('error');
        }
        fr.render('browse');
    }

    mountFS(data, fr) {
        data.recovery.services = [data.recovery.appliance_id];

        $.ajax({
            type: "POST",
            url: '/api/filebrowsing/mount/' + data.recovery.appliance_id + '/' + data.recovery.device_asid + '/'
                + data.recovery.job_id + '/' + data.recovery.drive,
            data: {},
            success: (response) => {
                if (response.success) {
                    if (data.filemountUseId) {
                        // expire the old use because we will no longer have access to it
                        $.post("/api/filebrowsing/complete/" + data.filemountUseId);
                    }
                    data.filemountUseId = (response && response.data && response.data.filemountUseId ? response.data.filemountUseId : null);
                    this.loadFS(data, fr);
                } else {
                    console.log('mount failed');
                }
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    resetRestoredItems() {
        // Count how many files or/and folders selected. Incremented when selected, decremented when excluded.
        // temp_files and temp_folders contain items path
        this.filesCounter = 0;
        this.tempFiles = [];
        this.foldersCounter = 0;
        this.tempFolders = [];
    }

    postRender(data, el, fr) {
        if (data.render.searchComplete) {
            const item_url = getUrl(data, 'files'), download_url = getUrl(data, 'download');
            const $cl = jQuery.fn.jColumnListView({
                id: 'cl',
                width: 400,
                columnWidth: 190,
                columnHeight: 430,
                columnMargin: 0,
                paramName: 'fs',
                columnNum: 30,
                appendToId: 'file-browser',
                elementId: 'root',
                removeULAfter: true,
                columnMinWidth: 120,
                columnMaxWidth: 200,
                childIndicator: true,
                showLabels: false,
                useSplitters: false,
                ajaxSource: {
                    method: 'post',
                    dataType: AJAX_DATA_TYPE_JSON,
                    contentType: 'application/json',
                    itemUrl: item_url,
                    onSuccess: function (reqObj, respStatus, respData) {
                        $('#cl-column-list-wrapper').mCustomScrollbar("scrollTo", "right");
                    },
                    onFailure: function (reqObj, respStatus, errObj) {
                    },
                    itemData: function (item) {
                        return JSON.stringify({
                            recoveryPoint: data.recovery.point,
                            path: item.getPath(),
                            filemountUseId: data.filemountUseId
                        });
                    }
                }
            });

            // horizontal scrollbar
            $('#cl-column-list-wrapper').mCustomScrollbar({
                horizontalScroll: 1,
                scrollInertia: 0,
                autoHideScrollbar: 1,
                advanced:{
                    autoExpandHorizontalScroll: true
                }
            });

            $cl.getColumnList().opts.onClick = function(ev, colIndex, itemIndex, item) {
                // prevent custom scroll bars from stacking
                $cl.getColumnList().getColumn(colIndex + 1).elem.mCustomScrollbar("destroy");
                $cl.getColumnList().getColumn(colIndex + 1).elem.mCustomScrollbar({
                    scrollInertia: 0,
                    autoHideScrollbar: 1
                });
            }

            $cl.getColumnList().getColumn(0).elem.mCustomScrollbar({
                scrollInertia: 0,
                autoHideScrollbar: 1
            });

            // Click file event
            $cl.get().on('onFileItemClick', (e, item) => {
                const is_selected = $(item.get()).is('.file-selected');
                const file_path = item.getPath().substring(1);

                if (!is_selected) {
                    this.filesCounter++;
                    parentChangeColor(item);

                    // Prevent dublicated files selection
                    if ($.inArray(file_path, this.tempFiles) === -1) {
                        this.tempFiles.push(file_path);
                    } else {
                        this.filesCounter--;
                    }

                    // Remove parent folder if a child file is selected
                    let parent_folder = file_path.substring(0, file_path.lastIndexOf("/"));
                    if ($.inArray(parent_folder, this.tempFolders) !== -1) {
                        this.foldersCounter--;
                        let index = this.tempFolders.indexOf(parent_folder);
                        if (index >= 0) {
                            this.tempFolders.splice(index, 1);
                        }
                    }

                    $('[data-flow-transition="transitionNext"]').removeClass('disabled');
                    $(item.get()).addClass('file-selected');
                    $('.file-select-counter').html('<strong>Files selected: ' + this.filesCounter + '</strong>').css('visibility', 'visible');
                    $('.folder-select-counter').html('<strong>Folders selected: ' + this.foldersCounter + '</strong>').css('visibility', 'visible');
                }
                else {
                    this.filesCounter--;
                    let index = this.tempFiles.indexOf(file_path);
                    if (index >= 0) {
                        this.tempFiles.splice(index, 1);
                    }
                    if (this.filesCounter === 0 && this.foldersCounter === 0) {
                        $('[data-flow-transition="transitionNext"]').addClass('disabled');
                    }
                    $(item.get()).removeClass('file-selected');
                    $('.file-select-counter').html('<strong>Files selected: ' + this.filesCounter + '</strong>').css('visibility', 'visible');
                }
            });

            // Click folder event
            $cl.get().on('onAfterColumnItemClick', (e, item) => {

                $('#cl-column-list-wrapper').mCustomScrollbar("update");
                const is_folder_selected = $(item.get()).is('.folder-selected');
                const folder_path = item.getPath().substring(1);

                if (!is_folder_selected) {
                    this.foldersCounter++;
                    $(item.get()).removeAttr("style");

                    parentChangeColor(item);

                    // Prevent dublicated folders selection
                    if ($.inArray(folder_path, this.tempFolders) === -1) {
                        this.tempFolders.push(folder_path);
                    }
                    else {
                        this.foldersCounter--;
                    }

                    // Ajax call updates child lists - update counters
                    this.filesCounter = parentCounterDecrement(this.filesCounter, this.tempFolders, this.tempFiles);
                    this.foldersCounter = parentCounterDecrement(this.foldersCounter, this.tempFolders);

                    // Remove parent folder if a child folder is selected
                    const parent_folder = folder_path.substring(0, folder_path.lastIndexOf("/"));
                    if ($.inArray(parent_folder, this.tempFolders) !== -1) {
                        this.foldersCounter--;
                        let index = this.tempFolders.indexOf(parent_folder);
                        if (index >= 0) {
                            this.tempFolders.splice(index, 1);
                        }
                    }
                    $('[data-flow-transition="transitionNext"]').removeClass('disabled');
                    $(item.get()).addClass('folder-selected');
                    $('.file-select-counter').html('<strong>Files selected: ' + this.filesCounter + '</strong>').css('visibility', 'visible');
                    $('.folder-select-counter').html('<strong>Folders selected: ' + this.foldersCounter + '</strong>').css('visibility', 'visible');
                }
                else {
                    this.foldersCounter--;

                    let index = this.tempFolders.indexOf(folder_path);
                    if (index >= 0) {
                        this.tempFolders.splice(index, 1);
                    }

                    if (this.filesCounter === 0 && this.foldersCounter === 0) {
                        $('[data-flow-transition="transitionNext"]').addClass('disabled');
                    }
                    $(item.get()).removeClass('folder-selected');
                    $('#cl-column-list .cvl-column-item-selected').removeClass('cvl-column-item-selected');
                    $('.folder-select-counter').html('<strong>Folders selected: ' + this.foldersCounter + '</strong>').css('visibility', 'visible');
                }
            });

            $cl.get().on('onItemHover', (e, item) => {
                let include_drive = '';
                if (typeof data.recovery.drive === undefined) {
                    include_drive = '/' + (data.recovery.drive + ':');
                }
                $('.file-browser-tray').html('<strong>' + data.recovery.device_name + include_drive + item.getPath() + '</strong>');
                $('.file-browser-tray').css('visibility', 'visible');
            });
            $cl.get().on('onItemLeave', function(e, item) {
                $('.file-browser-tray').css('visibility', 'hidden');
            });
        }
    }

    transitionNext(data, el, fr) {
        if ($(el).find('[data-flow-transition="transitionNext"]').is('.disabled')) { return; }

        // Define date created and expiration date
        const new_date = new Date();
        const date_created = new_date.getDownloadDate();
        new_date.setDate(new_date.getDate()+7);
        const dateExpired = new_date;
        data.restore.date = {
            created: date_created,
            expired: dateExpired.getFormattedDatePoint()
        }

        data.restore.counters = {
            filesCounter: this.filesCounter,
            foldersCounter: this.foldersCounter
        };

        // Single file
        if (this.filesCounter === 1 && this.foldersCounter === 0) {
            let data_selected = this.tempFiles;

            $.ajax({
                type : "POST",
                url : "/api/filebrowsing/file/" + data.recovery.appliance_id,
                data: JSON.stringify({ path: $.base64urlEncode(data.rootpath[0].root + '/' + this.tempFiles[0])}),
                success: (response) => {
                    data.restore.file = response.data;
                    // Single file < 50 MB
                    if (data.restore.file[0].download_type == SINGLE_FILE) {
                        //Remove decimals if bytes
                        if (data.restore.file[0].filesize < 1024) {
                            const size_bytes = data.restore.file[0].filesizeReadable;
                            const decimals = size_bytes.substr(size_bytes.indexOf("."), 3);
                            data.restore.file[0].filesizeReadable = data.restore.file[0].filesizeReadable.replace(decimals,'');
                        }
                        data.isZipped = false;
                        data.restore.download_type = SINGLE_FILE;
                    }
                    // Single file > 50 MB and < 2 GB - using ZIP
                    else if (data.restore.file[0].download_type == SINGLE_ZIP) {
                        data.isZipped = true;
                        data.restore.download_type = SINGLE_ZIP;
                        data.restore.zip = {
                            type: "zip",
                            files: this.filesCounter,
                        };
                    }
                    // Single file > 2 Gb - using TAR
                    else {
                        data.isZipped = true;
                        data.restore.download_type = SINGLE_TAR;
                        data.restore.tar = {
                            type: "tar",
                            files: this.filesCounter,
                        };
                    }
                    data.restore.selected = data_selected;
                    fr.goTo('restore');
                },
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json"
            }).fail(fr.defaultAJAXErrorHandler);
        }
        // Folder(s) + file(s)
        else {
            data.isZipped = true;
            let dataSelected = this.tempFiles.concat(this.tempFolders);
            data.restore.selected = dataSelected;
            data.restore.download_type = MULTIPLE_TAR;
            data.restore.tar = {
                type: "tar",
                files: this.filesCounter,
                folders: this.foldersCounter
            };
            fr.goTo('restore');
        }
    }

}
